export const filterDialog = {
  title: {
    en: 'Filter',
    nb: 'Filtrer',
    nn: 'Filtrer',
  },
  showResults: {
    en: 'Show {count} results',
    nb: 'Vis {count} treff',
    nn: 'Vis {count} treff',
  },
  resetFilters: {
    en: 'Reset filters',
    nb: 'Nullstill filter',
    nn: 'Nullstill filter',
  },
} as const;
